import React from 'react';
import { createClient } from 'urql';
import Hydrate from './Hydrate';
var client = createClient({
  url: '/api/graphql',
  fetchOptions: {
    credentials: 'include'
  }
});
export default function HydrateFrontStore() {
  return /*#__PURE__*/React.createElement(Hydrate, {
    client: client
  });
}